/**
 * Builds the cursosInscritos array for registrar-y-enviar from UI rows.
 * Drops empty selections and removes duplicate course ids.
 */
export function uniqueCourseIdsFromRows(rows) {
  const trimmed = rows
    .map((row) => row.cursoId)
    .filter((id) => typeof id === "string" && id.trim() !== "")
    .map((id) => id.trim());
  return [...new Set(trimmed)];
}
